module.exports = __webpack_public_path__ + "img/STERiGLIDE_04_01.ef2467f1.jpg";